import { Quote, Star } from "lucide-react";

const testimonials = [
  {
    rating: 5,
    title: "Windows troubleshooting resolution",
    quote: "Got my windows issue resolved within 12 hours and it is like brand new now. Really cooperative and knows his stuff for sure. Highly recommended.",
    name: "Jehanzaib",
    date: "May 4, 2025",
    source: "ThakThak.ca",
  },
  {
    rating: 5,
    quote: "Quick responses, easy transaction, arrived on time, friendly service, and fair pricing. I would definitely recommend ZID IT Solutions.",
    name: "Dan",
    role: "Verified Kijiji Customer",
  },
  {
    rating: 5,
    quote: "Quick responses, friendly service, on-time arrival, and exactly as described. Smooth transaction with fair pricing. Highly recommended!",
    name: "AJ",
    role: "Verified Kijiji Customer",
  },
  {
    rating: 5,
    quote: "Great service! Communication was quick and friendly, arrived exactly on time, and the entire transaction was smooth and hassle-free. Highly recommended!",
    name: "Sam",
    role: "Verified Kijiji Customer",
  },
  {
    rating: 5,
    quote: "Excellent experience! Communication was fast and friendly, the transaction was smooth, and everything was exactly as described. Arrived on time, offered fair pricing, and made the entire process easy. Highly recommended!",
    name: "Lynn",
    role: "Verified Kijiji Customer",
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 sm:py-32 bg-slate-50 border-y border-slate-200 overflow-hidden">
      <div className="container mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-blue-600">Client Reviews</span>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-slate-950 mt-4 whitespace-nowrap">
            Trusted by businesses like yours
          </h2>
        </div>
      </div>

      <div className="marquee mt-14 group">
        <div className="marquee-track">
          {[...testimonials, ...testimonials].map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="marquee-card bg-white border border-slate-200 p-8 sm:p-10 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <Quote size={36} className="text-blue-600" />
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating || 5 }).map((_, s) => (
                    <Star key={s} size={16} className="text-amber-400 fill-amber-400" />
                  ))}
                </div>
              </div>
              {t.title && (
                <h3 className="font-heading font-bold text-slate-950 mt-6">{t.title}</h3>
              )}
              <p className={`text-lg text-slate-800 leading-relaxed ${t.title ? "mt-2" : "mt-6"} flex-1`}>
                "{t.quote}"
              </p>
              <div className="mt-8 pt-6 border-t border-slate-200">
                <div className="font-heading font-bold text-slate-950">{t.name}</div>
                <div className="text-sm text-slate-500">
                  {t.role || (t.date && `${t.date}`)}
                  {t.source && (
                    <> · via <span className="font-semibold text-blue-600">{t.source}</span></>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
